import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 16 16",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "5",
    y: "5",
    width: "9",
    height: "9",
    rx: "1",
    stroke: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 3V2H2v8h1",
    stroke: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.text && !_ctx.duplicate)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: _normalizeClass(["copy-field-button", {'copy-field-inline':_ctx.inline}]),
        title: '复制'+_ctx.label,
        "aria-label": '复制'+_ctx.label,
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args)), ["stop"]))
      }, _hoisted_3, 10, _hoisted_1))
    : _createCommentVNode("", true)
}